import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import AppShell from "@/components/AppShell";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ChevronLeft, BookOpen } from "lucide-react";

export default function HelpKbCategory() {
  const { slug } = useParams();
  const [articles, setArticles] = useState([]);
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const [arts, cats] = await Promise.all([
          api.get("/kb/articles", { params: { category: slug, limit: 50 } }),
          api.get("/kb/categories"),
        ]);
        setArticles(arts.data.items || []);
        setCategory((cats.data.items || []).find((c) => c.slug === slug) || null);
      } catch (e) { toast.error(formatApiError(e)); }
      finally { setLoading(false); }
    })();
  }, [slug]);

  return (
    <AppShell title={category?.name || "Category"}>
      <div className="max-w-4xl mx-auto py-8 px-4">
        <Link to="/help/kb" className="inline-flex items-center text-sm text-navy-500 hover:text-navy-900 mb-4" data-testid="kb-back">
          <ChevronLeft className="w-4 h-4 mr-1" /> Back to knowledge base
        </Link>
        <h1 className="text-2xl font-semibold mb-1" data-testid="kb-category-heading">{category?.name || slug}</h1>
        {category?.description && <p className="text-sm text-navy-500 mb-6">{category.description}</p>}

        {loading ? (
          <div className="text-xs text-navy-400">Loading…</div>
        ) : articles.length === 0 ? (
          <div className="eb-card p-8 text-center">
            <BookOpen className="w-8 h-8 text-navy-300 mx-auto mb-2" />
            <p className="text-sm text-navy-500">No articles in this category yet.</p>
          </div>
        ) : (
          <div className="space-y-2" data-testid="kb-category-articles">
            {articles.map((a) => (
              <Link
                key={a.id}
                to={`/help/kb/${a.slug}`}
                className="eb-card p-4 block hover:border-orange-300 transition-colors"
                data-testid={`kb-article-${a.slug}`}
              >
                <div className="font-semibold text-navy-900 dark:text-white">{a.title}</div>
                <div className="text-xs text-navy-500 mt-1">{a.summary}</div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </AppShell>
  );
}
